// TODO: This is a temporary AngularJS bridge store.
// Once the visit route migrates to Angular, delete this store and move the active patient
// ownership to the users domain store.
// See: .amazonq/rules/inter-domain-communication.md — Store as Single Source of Truth
import { Injectable, signal, inject } from '@angular/core';
import { injectDispatch, Events, withEventHandlers } from '@ngrx/signals/events';
import { messagingPageEvents } from '@messaging/events';
import { visitBridgePageEvents } from './visit-bridge.events';

@Injectable({ providedIn: 'root' })
export class VisitBridgeStore {
  private readonly dispatch = injectDispatch(visitBridgePageEvents);
  private readonly dispatchMessaging = injectDispatch(messagingPageEvents);
  private readonly events = inject(Events);

  private readonly _activePatientId = signal<number | null>(null);

  constructor() {
    // Listen to patientIdSelected from any source and store it
    this.events.on(messagingPageEvents.patientIdSelected).subscribe(({ payload }) => {
      this._activePatientId.set(payload.patientId);
      // Immediately respond so consumers don't need to request separately
      this.dispatch.activePatientLoaded({ patientId: payload.patientId });
    });

    // When a component requests the active patient, respond with what we have
    this.events.on(visitBridgePageEvents.activePatientRequested).subscribe(() => {
      const patientId = this._activePatientId();
      if (patientId) {
        this.dispatch.activePatientLoaded({ patientId });
      }
    });
  }

  /** Called from AngularJS visit controller to set the active patient */
  setActivePatient(patientId: number): void {
    this.dispatchMessaging.patientIdSelected({ patientId });
  }
}

